var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRefreshLightIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 10,
  fill: "none",
  viewBox: "0 0 10 10"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#406A68",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.151,
  d: "M8.761 4.15a4.144 4.144 0 0 0-7.93-1.024M.575 1.08v2.046h2.047M.575 5.173a4.144 4.144 0 0 0 7.93 1.023m.256 2.046V6.196H6.715"
})));
export default SvgRefreshLightIcon;